import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { MatDialog } from '@angular/material';
import { Ng2DeviceService } from 'ng2-device-detector';
import { ConfigurationService } from '../services/configuration.service';
import { RequisitionService } from '../services/requisition.service';
import { ContractRequisition } from '../models/contractRequisition';
import { Requisition } from '../models/requisition';
import { AgmCoreModule } from '@agm/core';

@Component({
  selector: 'app-form-qa',
  templateUrl: './form-qa.component.html',
  styleUrls: ['./form-qa.component.css']
})
export class FormQaComponent implements OnInit {

  @Input() jobId: string;
  @Input() disabled: boolean;
  public publicating: boolean;
  public qas: any;
  public questionFormGroup: FormGroup;
  public answer: String[];

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private deviceService: Ng2DeviceService,
    private configurationService: ConfigurationService,
    private requisitionService: RequisitionService
  ) { }

  ngOnInit() {
    this.questionFormGroup = this.fb.group({
      answer: ['', Validators.required],
    });

    this.answer = [];

    this.publicating = false;
    this.getQas();
  }

  getQas() {
    this.publicating = true;
    this.requisitionService.getQa(this.jobId)
    .subscribe(
      res => {
        this.qas = res.qa;
        this.publicating = false;
      },
      () => {
        console.log('Error retrieving Qa');
        this.publicating = false;
      }
    );
  }

  onPutQuestion(qa, answer) {
    console.log(answer);
    this.requisitionService.putQuestionAnswer(qa.id, answer)
    .subscribe(
      data => {
        this.getQas();
      },
      error => {
        const errorMessage = <any>error;
        this.dialog.open(MessageBoxDialog, {data: {message: 'Hubo un error al realizar la pregunta: ' + errorMessage, information: true, showIcon: true}});
      }
    );
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/form-qa/form-qa.component.ts